import { useQuery } from 'react-query';

import { createHttpClient } from '@api/http-client';
import { END_POINTS } from '@constants/api-endpoints';
import { QUERY_KEYS } from '@constants/query-keys';

export const useGetLabelsUsageCount = (labelId: number) => {
  const client = createHttpClient();

  const query = useQuery(
    [QUERY_KEYS.LABELS.LABEL_USAGE_COUNT, labelId],
    () =>
      client<{ count: number }>({
        url: END_POINTS.LABELS.GET_LABEL_USAGE_COUNT(labelId),
      }),
    {
      enabled: !!labelId,
    },
  );

  const instanceCount = query.data?.count;

  return { ...query, instanceCount };
};
